import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const LanguageArtsLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_7_"
        x1="427.88"
        x2="491.433"
        y1="66.614"
        y2="66.614"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_7_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M476.9 91.1l-23.4 4.8c-8.5 1.8-16.8-3.7-18.5-12.2l-4.8-23.1c-1.8-8.5 3.7-16.8 12.2-18.5l23.4-4.8c8.5-1.8 16.8 3.7 18.5 12.2l4.8 23.1c1.8 8.5-3.7 16.8-12.2 18.5z"
      />
      <path
        fill="#FFF6B4"
        d="M457.7 89.7c-6.2-1.5-4.8 7.8-4.8 7.8s5.9 3.7 12.6.1c-.9-4.8-4.8-7.2-7.8-7.9zM469.7 91.5c-3.1-.7-2.4 3.8-2.4 3.8s2.9 1.8 6.2 0c-.4-2.2-2.3-3.4-3.8-3.8z"
      />
      <image
        width="44"
        height="44"
        x="438"
        y="44.7"
        transform="rotate(-11.69 460 66.7)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_6_"
        x1="487.929"
        x2="555.452"
        y1="108.183"
        y2="108.183"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_6_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M530.1 139.6l-25.6-3.9c-9.3-1.4-15.7-10.1-14.3-19.4L494 91c1.4-9.3 10.1-15.7 19.4-14.3l25.6 3.9c9.3 1.4 15.7 10.1 14.3 19.4l-3.8 25.3c-1.5 9.3-10.1 15.7-19.4 14.3z"
      />
      <path
        fill="#FFF6B4"
        d="M514.5 134.5c-5.6-3.1-6.7 6.2-6.7 6.2s4.7 5.1 12.1 3.5c.3-4.8-2.8-8.2-5.4-9.7zM527 136.4c-3.9-.9-3 4.9-3 4.9s3.8 2.3 8 0c-.6-2.9-3.1-4.4-5-4.9z"
      />
      <image
        width="44"
        height="44"
        x="499.5"
        y="87"
        transform="rotate(8.58 521.5 109)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_5_"
        x1="564.252"
        x2="639.061"
        y1="130.613"
        y2="130.613"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_5_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M624.5 156.6l-26.3 8.4c-9.5 3-19.7-2.2-22.8-11.7l-8.3-26c-3-9.5 2.2-19.7 11.7-22.8l26.3-8.4c9.5-3 19.7 2.2 22.8 11.7l8.3 26c3 9.6-2.2 19.8-11.7 22.8z"
      />
      <path
        fill="#FFF6B4"
        d="M612.5 157.6c-5.7-2.9-6.4 6.5-6.4 6.5s4.9 4.9 12.2 3c.2-5-3-8.2-5.8-9.5zM589.3 161.2c-5-1.2-3.8 6.3-3.8 6.3s4.8 3 10.1.1c-.8-3.9-3.9-5.9-6.3-6.4z"
      />
      <image
        width="44"
        height="44"
        x="579.5"
        y="109"
        transform="rotate(-17.75 601.5 131)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_8_"
        x1="478.175"
        x2="548.883"
        y1="227.51"
        y2="227.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_8_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M537 250.8l-29.1 9.3c-7.5 2.4-15.5-1.7-17.9-9.2l-9.2-28.8c-2.4-7.5 1.7-15.5 9.2-17.9l29.1-9.3c7.5-2.4 15.5 1.7 17.9 9.2l9.2 28.8c2.4 7.5-1.7 15.5-9.2 17.9z"
      />
      <image
        width="44"
        height="44"
        x="491.5"
        y="206"
        transform="rotate(-17.75 513.5 228)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF6B4"
        d="M580.4 259.9c-5.5-1.3-4.2 6.9-4.2 6.9s5.3 3.2 11.1.1c-.8-4.2-4.2-6.3-6.9-7z"
      />
      <linearGradient
        id="SVGID_3_"
        x1="549.091"
        x2="619.798"
        y1="218.327"
        y2="218.327"
        gradientTransform="rotate(16.219 592.677 222.333)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_3_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M601.9 245.1l-30.5.8c-7.8.2-14.4-6-14.6-13.8l-.8-30.2c-.2-7.8 6-14.4 13.8-14.6l30.5-.8c7.8-.2 14.4 6 14.6 13.8l.8 30.2c.3 7.8-5.9 14.4-13.8 14.6z"
      />
      <image
        width="44"
        height="44"
        x="563.5"
        y="195"
        transform="rotate(-1.53 585.5 217)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_4_"
        x1="629.318"
        x2="691.327"
        y1="232.946"
        y2="232.946"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_4_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M674.3 261.8l-31.8-2.2c-6.6-.5-11.6-6.2-11.2-12.8l2.1-31.5c.5-6.6 6.2-11.6 12.8-11.2l31.8 2.2c6.6.5 11.6 6.2 11.2 12.8l-2.1 31.5c-.4 6.6-6.1 11.6-12.8 11.2z"
      />
      <path
        fill="#FFF6B4"
        d="M647.4 255.9c-5.5-1.3-4.2 6.9-4.2 6.9s5.3 3.2 11.1.1c-.8-4.2-4.2-6.3-6.9-7zM661.4 260c-4-1-3.1 5-3.1 5s3.8 2.4 8.1 0c-.5-3-3-4.5-5-5z"
      />
      <image
        width="44"
        height="44"
        x="638.3"
        y="211"
        transform="rotate(3.9 660.3 233)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g id="group-6" transform="translate(-15, -23)">
      <g id="element-6">
        <g id="component-item-6">
          <g id="Language_x5F_arts">
            <ellipse
              cx="562.8"
              cy="250.8"
              fill="#55A32A"
              opacity="0.6"
              rx="159"
              ry="52.7"
            />
            <path
              fill="#FFDD83"
              d="M670.4 284.3c18.9-11.6 21.1-44.3-18.3-85.9 53.4-5.4-78.2-111.5-169.5-125.5-49.2-7.6-81.4-.3-89.7 24.4 5.2 16 1.2 25.6 8.6 45.2-15.8 3.9-23.4 15.4-12.6 40.5 2.8 10.4 5.3 16.6 15.6 28.4-41.1 11.1 29.5 60.2 54.8 67.5 106.1 30.7 191.5 17.4 211.1 5.4z"
            />
            <path
              fill="#F0B966"
              d="M385.5 154.4s-3.9 10.4 8.8 25.2c12.6 14.8 130.6 35.2 154.9 34.9-40 7.4-139.8-10.4-157.7-27.9-17.9-17.4-6-32.2-6-32.2zM569.9 209.1s-11.6 9.4 2.5 14.8c14 5.4 83.2-3 83.2-3s-67.1 19.8-86.4 9.1c-19.3-10.8.7-20.9.7-20.9zM394.3 217.1c-6.3 7 6.2 18.9 48.1 25.9 23.5 3.9 66.1-4.9 66.1-4.9s-47.2 19.7-95.2 5.2c-33.9-10.2-19-26.2-19-26.2z"
            />
            <path
              fill="#E09350"
              d="M394.7 100.2s0 34.1 6.8 42.3c37.4 32.1 112.6 70.7 124.9 74 24.8 3.5 42.5-8.1 42.5-8.1s13.3 5.4 29.9 6c16.5.7 28.4-2.7 29.5-3 1.1-.3 16.5 5.4 23.5 4s5.3-11.4 5.3-11.4l-6.3-7s-45.9 1.7-124.6-27.9-131.5-68.9-131.5-68.9z"
            />
            <path
              fill="#F0B966"
              d="M401 84.6c-4.2 4-9.5 8.8-4.2 15.9 2.7 3.6 13.6 9.4 20.7 8.6-.8 3.5 6.6 10.2 11.6 13.1 9.3 5.5 17.4 9 27.2 13.8 7.7 3.8 18.3 2.4 25.1 7.6 14.4 10.9 30.9 15.1 46.4 20 9.8 3.1 17.3 10.2 26 13.1 20.4 6.7 34 6.4 46.4 9.1 6.2 1.3 17 5.6 22.1 6.4 7.7 1.2 13.9-1.8 19.3-1.7 11.9 6.4 20.3 1.4 22.8-1.5 1.6 7.6-4.2 12.1-15.8 13.8-14.3 2.2-28.4 1-55.8-10.1-10.8-4.4-25-1-37.1-4.8-9.3-2.9-16.8-12.3-26.1-15.6-34.3-12.4-68.6-25.1-92-37.4-5.6-2.9-11.1 1.5-21.8-6.7-14.9-11.4-8-12.8-11.2-14.8-30.1-18.1-3.6-28.8-3.6-28.8z"
            />
            <path
              fill="#F0B966"
              d="M579.6 184.3c2.1-2.5-2.1-9.1-2.1-9.1s-10.5-1.5-12.6-5c-2.1-3.5-5.8-13.1-5.8-13.1L548 138l15 17.6 4.7 11.8 15.5 6 8.7 13.3-12.3-2.4z"
            />
            <path
              fill="#F0B966"
              d="M562.5 161.4L555.9 165.2 541.9 157.6 556.9 168.2 564.8 166.2z"
            />
            <path
              fill="#F0B966"
              d="M405.7 108.3L417.5 109.1 428.1 101.5 449.7 108 428.6 104.7 421.5 118.3z"
            />
            <path
              fill="#F0B966"
              d="M421.8 111L430.8 110.5 440.2 117.1 428.4 112.5 420.7 115.8z"
            />
            <path
              fill="#F0B966"
              d="M644.7 193L632.4 182.6 622.6 169.9 632.1 186 639.5 195.4z"
            />
            <path
              fill="#E09350"
              d="M608.9 268.9c1.1 2-1.8 2-3.9 9.7-2.1 7.7-2.1 17.8-2.1 17.8l-3.2 2s-24.9 6-35.1 7.7c-10.2 1.7-29.9-9.1-29.9-9.1s-17.2-1.7-20.4-2.7-19.7-2.7-20.7-3.4-15.5-6.4-15.1-7.7c.4-1.3 1.8-33.9 1.8-33.9s20.7 21.8 35.1 23.5c14.4 1.7 53 7 60.4 6 7.5-.9 33.1-9.9 33.1-9.9z"
            />
            <path
              fill="#F0B966"
              d="M490.9 258.8c5.3 9.4 79 18.8 100.1 7.4 21.1-11.4.4-22.8.4-22.8s35.8 23.3 8.4 33.9c-27.4 10.5-102.6.5-108.9-18.5zM395.2 112.5l3.2 9.6 20.5 13.8 8.2 2.5-26.9-4s-9.7-7.6-9.7-8.6 4.7-13.3 4.7-13.3z"
            />
            <path
              fill="#FFDD83"
              d="M399.4 119.9c-3.3-2.4-4.9 3.2-4.9 3.2s2.5 3.6 7.5 3.3c.7-3-1-5.3-2.6-6.5zM405.2 127.3c-1.6-1.2-2.4 1.6-2.4 1.6s1.3 1.8 3.7 1.6c.3-1.5-.5-2.6-1.3-3.2z"
            />
            <path
              fill="#FFF6B4"
              d="M397.5 156.8c-6.5-1.5-5 7.8-5 7.8s6.2 3.7 13.2.1c-.9-4.8-5-7.2-8.2-7.9zM408.6 167c-3.7-.9-2.8 4.4-2.8 4.4s3.5 2.1 7.5 0c-.6-2.6-2.9-4-4.7-4.4zM593.7 166.5c-3.5-.8-2.7 4.2-2.7 4.2s3.3 2 7.1 0c-.6-2.5-2.7-3.8-4.4-4.2zM529.8 149.9c-3.5-.8-2.7 4.2-2.7 4.2s3.3 2 7.1 0c-.6-2.5-2.8-3.8-4.4-4.2zM548 123.4c-3.5-.8-2.7 4.2-2.7 4.2s3.3 2 7.1 0c-.5-2.5-2.7-3.8-4.4-4.2z"
            />
            <path
              fill="#F0B966"
              d="M546.4 285.3s21.8 5.4 34.8 1c-14.1 12.4-26.4 5.7-34.8-1z"
            />
            <path
              fill="#E09350"
              d="M592.7 296.8s8.4 3.8 12.8 5c4.4 1.3 26.7-2.6 28-2.7s48.1-8.6 48.1-8.6-.4-19.2 1.1-23.6c-11.7 12.1-57.4 12.7-73.9-.3-13.9 23.3-16.1 30.2-16.1 30.2z"
            />
            <path
              fill="#F0B966"
              d="M604.3 258.1s1.1 9.4 32.3 14.8 45.7-11.7 46.7-16.8c3.7 5.7 4.2 3.9 1.6 12.3-9.8 5-35 13.6-51.9 12.1-17.6-3.7-29.8-19-29.8-19l1.1-3.4zM602.1 283.6s6.1 5 16.2 4.7c10-.3 26.3-2.5 26.3-2.5s-22.8 11.2-33 8.6c-10.2-2.7-9.5-10.8-9.5-10.8zM661.9 283.3c4.4-1.7 18.8-4.2 19.3-6 .5-1.8 1.1-3.7 1.1-3.7s10.9 4.7 8.3 7.7c-2.7 3-28.7 2-28.7 2z"
            />
            <path
              fill="#F0B966"
              d="M526.4 250.1L508.8 249.4 492 252.8 509.9 246.7 506.2 244.5 497.6 246.6 506 241.9 511.8 243.7 518.3 240.3z"
            />
            <path
              fill="#F0B966"
              d="M564.1 259L584.3 253.1 597.1 256.3 584.8 249.6 571.3 253.1z"
            />
            <path
              fill="#F0B966"
              d="M643.1 258.8L623.6 254.3 608.8 254.5 621.7 250.7 639.9 254.3z"
            />
            <path
              fill="#E09350"
              d="M384.5 177.6c1.9 3 3.8 9.8 5.4 12.1s5.1 12 6.1 14 8.5 7.8 8.5 7.8l14.7 6.5 51.1 1.3s29.2 3.8 30 3.5c.8-.3 21.9-7 21.9-7s-53.5-5.5-54.8-5.8-58.5-16.4-58.5-16.4l-24.4-16z"
            />
            <path
              fill="#F0B966"
              d="M509.2 178.2s14.2 8.8 15 9.1c.8.3 24.8 3.5 24.8 3.5l7.6.8s-11.9 4.5-12.6 4.8-9.5-.5-13.4-1.3-14.8-7.6-14.8-7.6l-6.6-9.3zM579.3 197.9l10.3 4.8 24 2.5-21.1 4.3s-11.9-5.5-12.6-6.3c-.9-.8-.6-5.3-.6-5.3z"
            />
            <path
              fill="#F0B966"
              d="M389.8 189.7L387 193.1 391.2 199.1 411.5 203.7 396.8 196.4z"
            />
            <path
              fill="#68C902"
              d="M540.7 309.6c-34.6-3.2-69.4-4.6-104.1-4.2-2.6-.6-5.2-1.3-7.8-1.9 1.3-.4 2.5-.7 3.8-1.1-.2-.5-.5-.6-.7-.3-.1-.4-.5-3.1-.3-4.9.2-1.8.4-3 .3-3.5.2.1.5.9.5 1.8.1-1.3.2-2.3.5-3 .2-.6.5-2.1.3-3.1.3-.2 1.1 3.1.9 7.8.2-1 .4-1.4.6-1.5v.2c.5-2.9.9-4.8.7-5.9.6.6 1.2 2.9 1 4.9.3-3.1.8-5.3 1.5-6.6.6-1.2 1.6-4.4 1.1-7 .6 0 1.6 4.6 1.6 11.4.2-.4.4-.7.7-.9.5-.4 1.4-1.8 1.2-3.8.3.3.6 2.8.4 6.1.4-.7.8-1.3 1.2-2.1 1.5-3.4 1.6-4.7 1.7-8.2 0-.8.4-1.1.6-.5.2.8.4 1.7.5 2.7.5.3 1 1.9 1 3.7.2-2.7.5-4.8 1-6 .5-1.3 1.2-4.3.7-6.2.7-.3 2.2 6.3 1.5 16 .4-2.1.9-2.7 1.2-3.1v.4c1.1-5.8 2-9.8 1.7-11.9 1.2 1.3 2.3 5.9 1.9 10 .7-6.2 2-10.9 3.3-13.4 1.4-2.5 3.5-8.9 2.6-14.2 1.3 0 3.1 9.5 2.8 23.2.5-.9.9-1.4 1.4-1.7 1.1-.7 2.9-3.5 2.7-7.7.6.7 1.1 5.8.6 12.5.9-1.5 1.7-2.6 2.6-4.3 3.3-6.9 3.5-9.5 3.9-16.7.1-1.7 1-2.1 1.3-1 1.4 5.6 1.5 12.6.2 20.7-.6 3.8-1.4 7-2.2 9.6h.9v-.1c.6-1.1 1.2-1.8 1.7-2.9 2.1-4.3 2.2-5.9 2.5-10.5.1-1.1.6-1.3.8-.6.9 3.5.9 7.9.1 13-.1.4-.1.7-.2 1.1h3.2c0-.3.1-.6.1-.9.3-2.4.7-4 .6-4.6.3.2.6 1.3.6 2.4.2-1.7.5-3.1.8-3.9.3-.8.9-2.7.6-4 .5-.2 1.3 4.2.6 10.3.3-1.3.7-1.7.8-2v.2c.9-3.8 1.5-6.3 1.4-7.7.7.9 1.3 3.8 1 6.5.6-4 1.5-7 2.4-8.6.9-1.6 2.4-5.7 2-9.1.8 0 1.8 6.2 1.3 15.1.3-.5.6-.9.9-1.1.7-.4 1.9-2.2 1.9-4.9.4.5.6 3.8.2 8.1.6-1 1.2-1.6 1.7-2.7 2.3-4.4 2.4-6.1 2.8-10.7.1-1.1.7-1.4.8-.6.8 3.7.8 8.2-.2 13.4-.5 2.4-1 4.4-1.5 6l.6.1c.4-.6.8-1.1 1.1-1.8 1.4-2.7 1.5-3.8 1.8-6.7.1-.7.4-.9.5-.4.5 2.3.5 5.2-.2 8.4-.1.3-.1.6-.2.9 16.4 2.2 28.9 6.1 41.9 11.1-2.5 0-5.1.5-7.7.9zm-94.6-11.3c0-.4 0-.9-.1-1.3-.2.8-.4 1.6-.6 2.2l.4-.1c.1-.3.2-.5.3-.8z"
            />
            <path
              fill="#68C902"
              d="M594.2 323.3c-18.2.8-36.5-.3-54.4-3.5l-3.6-2.7 2.1-.6c0-.5-.1-.7-.3-.4 0-.4.4-3.1.8-4.8.4-1.8.8-2.9.8-3.4.1.2.1 1-.1 1.8.3-1.3.6-2.3.8-2.9.2-.6.7-2 .7-3 .2-.1 0 3.2-1 7.8.3-1 .5-1.3.6-1.4v.2c.8-2.8 1.3-4.7 1.4-5.7.2.7 0 2.9-.4 4.9.7-3 1.4-5.2 1.9-6.3.5-1.2 1.5-4.2 1.7-6.8.3 0-.1 4.7-1.2 11.3.2-.4.3-.7.5-.8.3-.3.9-1.6 1.2-3.6.1.4-.2 2.8-.8 6.1.3-.7.6-1.2.9-2 1.3-3.3 1.5-4.5 2.1-8 .1-.8.4-1 .4-.5 0 .8-.1 1.8-.2 2.7.2.4.2 2-.1 3.7.5-2.6 1-4.7 1.4-5.9.4-1.2 1.2-4.1 1.2-6.1.3-.3.1 6.4-1.6 15.9.5-2 .8-2.6 1-3v.4c1.3-5.7 2.3-9.6 2.4-11.7.3 1.4.3 5.9-.4 10.1 1.1-6.2 2.3-10.7 3.2-13.1.9-2.4 2.6-8.7 2.8-14 .5.1.2 9.5-1.3 23.2.3-.8.6-1.4.8-1.7.6-.7 1.7-3.4 2-7.6.2.7-.1 5.8-.9 12.4.6-1.5 1.1-2.5 1.6-4.2 2.1-6.8 2.4-9.4 3.2-16.5.2-1.7.6-2.1.6-1 .2 5.6-.3 12.6-1.5 20.6-.6 3.8-1.2 7-1.8 9.6h.5v-.1c.4-1.1.7-1.8 1.1-2.9 1.3-4.3 1.5-5.9 1.9-10.4.1-1.1.4-1.3.4-.6.2 3.5-.1 7.9-.8 12.9-.1.4-.1.7-.2 1.1h1.6c0-.3.1-.6.1-.9.3-2.4.6-4 .6-4.6.1.2.2 1.3.1 2.4.2-1.7.4-3.1.6-3.9.2-.8.6-2.7.5-4 .2-.2.4 4.1-.2 10.3.2-1.3.4-1.7.5-2v.2c.6-3.7 1-6.3 1-7.7.3.9.5 3.8.2 6.5.5-4 1-7 1.5-8.6.5-1.6 1.3-5.7 1.2-9.2.3 0 .6 6.1.2 15 .2-.5.3-.9.5-1.1.3-.4 1-2.3 1-5 .2.5.2 3.8-.1 8.1.3-1 .6-1.7.9-2.8 1.1-4.5 1.2-6.1 1.5-10.8.1-1.1.3-1.4.4-.7.3 3.6.3 8.2-.2 13.3-.2 2.4-.5 4.4-.8 6h.3c.2-.7.4-1.1.6-1.8.7-2.8.8-3.9.9-6.8 0-.7.2-.9.2-.4.2 2.3.2 5.1-.1 8.4 0 .3-.1.6-.1.9 8.2 1.4 14.6 4.2 21.8 7.4-1.4.9-2.7 1.6-4.1 2.3zm-48.4-9.5c.1-.4.1-.9.2-1.3-.2.8-.4 1.5-.6 2.1l.2-.1c.1-.3.2-.5.2-.7zM709 318.8c-16.5-.3-33.1-.1-49.6.6s-33 1.9-49.4 3.6c-2.5-.4-5-.8-7.6-1.2 1.2-.5 2.3-.9 3.5-1.4-.3-.4-.5-.6-.7-.3-.1-.4-.7-3.1-.7-4.9 0-1.8.1-3.1-.1-3.5.2.1.6.9.7 1.7-.1-1.3 0-2.4.2-3 .2-.6.3-2.1 0-3.1.3-.2 1.4 3 1.6 7.7.1-1 .3-1.4.4-1.6v.2c.2-2.9.4-4.9.2-5.9.6.6 1.4 2.7 1.4 4.8 0-3.1.3-5.4.8-6.7.5-1.3 1.1-4.5.4-7.1.6-.1 1.9 4.5 2.6 11.2.2-.4.3-.8.5-.9.5-.4 1.1-1.9.8-3.9.3.3.8 2.8 1 6 .3-.8.7-1.4.9-2.2 1.1-3.5 1.1-4.8.9-8.3 0-.8.3-1.1.5-.6.3.8.5 1.7.7 2.7.5.3 1.1 1.8 1.3 3.6-.1-2.7.1-4.8.4-6.1.4-1.3.7-4.4.1-6.3.6-.4 2.7 6.1 2.9 15.8.2-2.1.6-2.8.9-3.2v.4c.5-5.9 1.1-10 .6-12 1.2 1.2 2.7 5.6 2.7 9.8.1-6.3.9-11 2-13.6 1.1-2.6 2.5-9.2 1.2-14.4 1.2-.1 3.8 9.2 4.7 22.9.4-.9.8-1.5 1.2-1.9 1-.8 2.5-3.7 2-7.9.7.7 1.5 5.7 1.7 12.4.7-1.6 1.4-2.7 2.1-4.5 2.6-7.1 2.5-9.7 2.4-16.9 0-1.7.8-2.2 1.1-1.1 1.8 5.5 2.5 12.5 1.9 20.6-.3 3.8-.8 7.1-1.3 9.8.3 0 .6-.1.9-.1v-.1c.5-1.1 1-1.9 1.4-3.1 1.6-4.5 1.6-6.1 1.5-10.6 0-1.1.5-1.4.7-.7 1.1 3.5 1.5 7.8 1.1 12.9 0 .4-.1.7-.1 1.1 1-.1 2-.2 3.1-.2v-.9c.1-2.4.4-4 .2-4.7.3.2.7 1.2.7 2.3 0-1.7.2-3.1.5-3.9.3-.8.6-2.8.2-4.1.4-.2 1.6 4 1.4 10.3.2-1.3.5-1.8.6-2v.2c.5-3.8 1-6.4.7-7.8.8.8 1.6 3.7 1.5 6.4.2-4.1.9-7.1 1.6-8.7.8-1.7 1.8-5.9 1.1-9.3.8 0 2.2 6 2.5 14.9.3-.6.5-1 .8-1.2.6-.5 1.7-2.3 1.4-5 .4.5.8 3.7.8 8 .5-1 1-1.7 1.4-2.9 1.8-4.6 1.8-6.2 1.9-10.9 0-1.1.5-1.4.7-.7 1.1 3.6 1.4 8.1.8 13.3-.3 2.4-.6 4.4-1 6.1h.6c.3-.7.6-1.1.9-1.9 1.1-2.9 1.2-3.9 1.2-6.8 0-.7.3-.9.5-.4.7 2.3.8 5.1.5 8.4 0 .3-.1.6-.1.9 15.8.9 27.9 3.9 40.6 7.9-2.5.8-5 1.5-7.5 2zm-90.6-3.6c-.1-.4-.1-.9-.2-1.3-.1.8-.2 1.6-.4 2.2l.4-.1c0-.3.1-.5.2-.8z"
            />
            <g>
              <path
                fill="#68C902"
                d="M535.9 407.1c-4.9 1.4-9.3 1.8-13.2 1.9-3.9.1-7.2-.1-10.1-.3-5.9-.5-11.8-1.2-17.6-2.3-11.6-2.1-23.1-5.4-34.1-9.9-1.4-1.2-2.7-2.6-4.1-3.9.9 0 1.8 0 2.7.1.1-.5 0-.7-.3-.5.1-.4 1-3 1.8-4.6.8-1.6 1.4-2.7 1.6-3.2.1.2-.1 1-.4 1.8.6-1.2 1.1-2.1 1.4-2.6.4-.5 1.1-1.8 1.4-2.7.2-.1-.6 3.1-2.6 7.4.5-.9.8-1.1.9-1.3 0 0 0 .1-.1.2 1.4-2.5 2.4-4.2 2.7-5.2.1.7-.4 2.9-1.3 4.8 1.3-2.8 2.5-4.7 3.3-5.7.8-1 2.5-3.7 3.2-6.2.3.1-.8 4.6-3.3 10.9.3-.3.5-.6.7-.7.4-.2 1.4-1.3 2.1-3.3.1.4-.7 2.8-1.9 5.8.5-.6.9-1 1.4-1.7 2.1-2.9 2.5-4.1 3.8-7.4.3-.8.6-.9.5-.4-.2.8-.4 1.7-.6 2.7.2.4-.1 2-.7 3.6 1-2.5 1.9-4.4 2.6-5.5.7-1.1 2-3.8 2.4-5.8.4-.2-.8 6.4-4.3 15.4.9-1.9 1.4-2.4 1.7-2.7 0 .1-.1.2-.1.3 2.5-5.3 4.2-9 4.7-11 .2 1.4-.5 6-2 9.9 2.3-5.8 4.3-10 5.7-12.2 1.5-2.2 4.3-8.1 5.3-13.3.6.2-1.1 9.5-4.8 22.7.5-.8.9-1.3 1.2-1.5.8-.5 2.5-3 3.4-7.1.2.8-.8 5.8-2.7 12.2.9-1.3 1.6-2.3 2.5-3.9 3.5-6.3 4-8.9 5.9-15.8.4-1.7.9-2 .8-.9-.5 5.6-1.8 12.5-4.3 20.2-1.2 3.7-2.3 6.7-3.4 9.1l.6.1v-.1c.6-1 1.1-1.6 1.7-2.7 2.2-4 2.5-5.6 3.6-10 .3-1 .6-1.3.6-.5-.2 3.6-1 7.9-2.5 12.7-.1.4-.2.7-.3 1 .7.1 1.3.2 2 .3.1-.3.1-.6.2-.9.6-2.3 1.1-3.9 1.2-4.5.2.2.2 1.3-.1 2.4.4-1.7.8-3 1.2-3.8.3-.8 1-2.6 1-3.9.3-.2.1 4.2-1.3 10.3.4-1.3.7-1.7.8-1.9v.2c1.1-3.6 1.9-6.1 2-7.5.3.9.2 3.9-.4 6.5 1-3.9 1.9-6.8 2.7-8.3.8-1.5 2.1-5.5 2.4-8.9.4.1.2 6.2-1.2 15 .3-.5.5-.9.7-1.1.5-.4 1.4-2.1 1.7-4.8.2.5-.1 3.8-.8 8 .5-.9.9-1.6 1.3-2.6 1.8-4.3 2-6 2.7-10.6.2-1.1.5-1.3.5-.6.1 3.7-.3 8.2-1.4 13.3-.5 2.3-1 4.3-1.5 5.9l.4.1c.3-.6.6-1.1.9-1.8 1.1-2.7 1.3-3.8 1.7-6.7.1-.7.3-.8.3-.4.1 2.3-.1 5.1-.8 8.4-.1.3-.1.6-.2.9 2.6.6 5 1.2 7.4 1.9 2.4.7 5 1.3 7.8 1.9 2.8.6 5.9 1 9.3 1.1 3.4 0 7.3-.4 11.4-1.6-2 2.5-4.7 4.3-7.4 5.8zm-66.5-14.8c.1-.4.3-.8.4-1.3-.4.7-.8 1.4-1.1 1.9h.3c.1-.2.2-.4.4-.6z"
              />
            </g>
            <g fill="#FFF" transform="translate(30, -30)">
              <path d="M535.8 333.5h2c.6 0 1 0 1.2-.1.3 0 .6 0 .9-.1h.5c.3 0 .4.1.5.2.1.1.2.3.2.6 0 .1 0 .3.1.4v1c0 .2-.1.4-.2.5s-.3.2-.6.2c-.7.1-1.4.1-2.1.1-.7 0-1.3.1-2 .1h-1.5c-.5 0-1 0-1.5-.1-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.5-.1-1.1-.1-2.2-.1-3.4 0-1.3 0-2.7.1-4 .1-1.4.2-2.7.4-4.1 0-.3.1-.5.3-.6.1-.1.4-.2.7-.2h.9c.3 0 .6.1.9.1.2 0 .4.1.5.3.1.1.1.3.1.4v.3c0 .1 0 .2-.1.3-.2 1.2-.3 2.5-.4 3.8-.1 1.4-.2 2.8-.2 4.2v.8zM549.1 336.4c-.3 0-.5-.1-.6-.3-.1-.1-.1-.3-.1-.6-.4.3-.8.5-1.3.7-.5.2-.9.2-1.4.2-.6 0-1.1-.1-1.5-.3-.5-.2-.8-.4-1.2-.8-.3-.3-.6-.7-.7-1.2-.2-.5-.3-.9-.3-1.5 0-.8.1-1.5.4-2.1s.7-1.2 1.2-1.7 1-.9 1.6-1.2c.6-.3 1.2-.4 1.9-.4.5 0 1.1.1 1.6.3 0-.2.1-.4.1-.5.1-.1.2-.1.4-.1s.5 0 .8.1c.3 0 .6.1.9.2.1 0 .3.1.4.1.1 0 .2.1.3.2.1.1.1.2.2.3v.5c0 1.1 0 2.2-.1 3.4-.1 1.2-.2 2.3-.3 3.4 0 .3-.1.6-.3.7-.1.1-.3.2-.7.3h-1.1c-.1.3-.1.3-.2.3zm-.6-3.4c0-.5 0-.9.1-1.4 0-.5 0-.9.1-1.4-.2-.1-.3-.1-.5-.2-.2 0-.4-.1-.6-.1-.4 0-.7.1-1 .2-.3.2-.5.4-.7.6-.2.2-.3.5-.4.8-.1.3-.2.5-.2.8 0 .5.1.8.4 1.1.3.3.7.4 1.2.4.3 0 .6-.1.9-.2.1-.2.4-.4.7-.6zM553.2 328.5c0-.3 0-.5.1-.7 0-.2.2-.3.4-.4.1 0 .3-.1.5-.1s.4 0 .6-.1h1.1c.2 0 .3 0 .4.1.1.1.1.2.1.3v.5c.4-.3.9-.5 1.4-.7.5-.2 1-.2 1.5-.2.2 0 .5 0 .8.1l.9.3c.3.2.5.4.7.8.2.3.3.8.3 1.4v1.1c0 .4 0 .9-.1 1.4 0 .5-.1 1-.1 1.5-.1.5-.1 1.1-.2 1.6 0 .2-.1.4-.2.6-.1.2-.3.3-.6.3h-.7c-.3 0-.6-.1-.8-.1-.4-.1-.6-.3-.6-.8v-.5c0-.2 0-.5.1-.8 0-.3.1-.7.1-1.2V331c0-.3-.1-.5-.2-.7-.1-.2-.3-.3-.5-.3-.3 0-.6.1-.9.2-.3.1-.7.3-1 .5 0 .8 0 1.5.1 2.3 0 .7.1 1.5.2 2.2v.4c0 .2-.1.4-.2.5-.1.1-.4.2-.8.2h-1.2c-.4 0-.6-.1-.7-.2-.1-.1-.2-.4-.2-.6-.1-.9-.2-1.8-.2-2.8s-.1-1.9-.1-2.8v-.6-.8zM572 338.6c0 .3-.2.5-.3.7s-.4.4-.6.6c-.2.2-.5.3-.9.4-.3.1-.7.2-1.1.2-.8 0-1.6-.1-2.3-.2-.7-.1-1.4-.4-2.1-.7-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.4 0-.2.1-.4.2-.7.1-.3.2-.6.3-.8.1-.1.1-.2.2-.3.1-.1.2-.1.3-.1.1 0 .3 0 .4.1.6.2 1.1.3 1.7.4.5.1 1.1.1 1.7.1.1-.4.1-.8.2-1.2 0-.4.1-.8.1-1.3-.8.6-1.7.9-2.7.9-.6 0-1.1-.1-1.5-.3-.5-.2-.8-.4-1.2-.8-.3-.3-.6-.7-.7-1.1-.2-.4-.3-.9-.3-1.4 0-.7.1-1.4.4-2 .3-.6.7-1.2 1.2-1.7s1-.8 1.6-1.1c.6-.3 1.2-.4 1.9-.4h.7c.2 0 .4.1.7.2 0-.2.1-.3.1-.4.1-.1.2-.1.3-.1.2 0 .4 0 .8.1.4 0 .7.1 1 .2.1 0 .3.1.4.1.1 0 .2.1.3.2.1.1.1.2.2.3 0 .1.1.3.1.5 0 .3 0 .7.1 1.2v3.4c0 .7 0 1.3-.1 2 0 .7-.1 1.3-.1 1.9s-.3 1.3-.4 1.8zm-2.6-5.8v-1-1.8c-.1-.1-.3-.1-.5-.1h-.6c-.4 0-.7.1-1 .2-.3.2-.5.3-.7.6-.2.2-.3.5-.4.7-.1.3-.2.5-.2.7 0 .4.1.8.4 1 .3.3.7.4 1.1.4.8 0 1.3-.2 1.9-.7zM582.6 335.1c0 .3 0 .5-.1.7 0 .2-.2.3-.4.4-.3.1-.7.2-1 .3-.4.1-.7.1-1 .1-.4 0-.6-.2-.6-.6v-.2-.3c-.4.3-.9.5-1.4.7-.5.2-1 .2-1.5.2-.2 0-.5 0-.8-.1l-.9-.3c-.3-.2-.5-.4-.7-.8-.2-.3-.3-.8-.3-1.4v-1.1c0-.4 0-.9.1-1.4 0-.5.1-1 .1-1.5.1-.5.1-1.1.2-1.6 0-.3.2-.6.4-.7.2-.1.5-.2.9-.2h.6c.2 0 .4.1.6.1.2.1.3.2.4.3.1.1.1.3.1.5v.7c0 .3-.1.7-.1 1.1 0 .4-.1.8-.1 1.3v1.4c0 .3.1.5.2.7.1.2.3.3.5.3.3 0 .6-.1 1-.2.3-.1.7-.3 1-.5v-1.6c0-.5-.1-1-.1-1.4 0-.4-.1-.8-.1-1.1v-.6c0-.2.1-.4.2-.6s.4-.2.7-.3c.1 0 .3-.1.5-.1h.5c.3 0 .6.1.8.2.2.1.3.3.3.6.1.9.2 1.8.2 2.8.1.9.1 1.9.1 2.8v.7c-.3.3-.3.5-.3.7zM590.7 336.4c-.3 0-.5-.1-.6-.3-.1-.1-.1-.3-.1-.6-.4.3-.8.5-1.3.7-.5.2-.9.2-1.4.2-.6 0-1.1-.1-1.5-.3-.5-.2-.8-.4-1.2-.8-.3-.3-.6-.7-.7-1.2-.2-.5-.3-.9-.3-1.5 0-.8.1-1.5.4-2.1.3-.7.7-1.2 1.2-1.7s1-.9 1.6-1.2c.6-.3 1.2-.4 1.9-.4.5 0 1.1.1 1.6.3 0-.2.1-.4.1-.5.1-.1.2-.1.4-.1s.5 0 .8.1c.3 0 .6.1.9.2.1 0 .3.1.4.1.1 0 .2.1.3.2.1.1.1.2.2.3v.5c0 1.1 0 2.2-.1 3.4s-.2 2.3-.3 3.4c0 .3-.1.6-.3.7-.1.1-.3.2-.7.3h-1.1c0 .3-.1.3-.2.3zm-.6-3.4c0-.5 0-.9.1-1.4 0-.5 0-.9.1-1.4-.2-.1-.3-.1-.5-.2-.2 0-.4-.1-.6-.1-.4 0-.7.1-1 .2-.3.2-.5.4-.7.6-.2.2-.3.5-.4.8-.1.3-.2.5-.2.8 0 .5.1.8.4 1.1.3.3.7.4 1.2.4.3 0 .6-.1.9-.2.2-.2.5-.4.7-.6zM603.6 338.6c0 .3-.2.5-.3.7s-.4.4-.6.6c-.2.2-.5.3-.9.4-.3.1-.7.2-1.1.2-.8 0-1.6-.1-2.3-.2-.7-.1-1.4-.4-2.1-.7-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.4 0-.2.1-.4.2-.7.1-.3.2-.6.3-.8.1-.1.1-.2.2-.3.1-.1.2-.1.3-.1.1 0 .3 0 .4.1.6.2 1.1.3 1.7.4.5.1 1.1.1 1.7.1.1-.4.1-.8.2-1.2 0-.4.1-.8.1-1.3-.8.6-1.7.9-2.7.9-.6 0-1.1-.1-1.5-.3-.5-.2-.8-.4-1.2-.8-.3-.3-.6-.7-.7-1.1-.2-.4-.3-.9-.3-1.4 0-.7.1-1.4.4-2 .3-.6.7-1.2 1.2-1.7s1-.8 1.6-1.1c.6-.3 1.2-.4 1.9-.4h.7c.2 0 .4.1.7.2 0-.2.1-.3.1-.4.1-.1.2-.1.3-.1.2 0 .4 0 .8.1.4 0 .7.1 1 .2.1 0 .3.1.4.1.1 0 .2.1.3.2.1.1.1.2.2.3 0 .1.1.3.1.5 0 .3 0 .7.1 1.2v3.4c0 .7 0 1.3-.1 2 0 .7-.1 1.3-.1 1.9s-.4 1.3-.4 1.8zm-2.7-5.8v-1-1.8c-.1-.1-.3-.1-.5-.1h-.6c-.4 0-.7.1-1 .2-.3.2-.5.3-.7.6-.2.2-.3.5-.4.7-.1.3-.2.5-.2.7 0 .4.1.8.4 1s.7.4 1.1.4c.8 0 1.4-.2 1.9-.7zM613.7 332.1c-.3.1-.7.2-1.1.3-.4.1-.9.2-1.4.3-.5.1-1 .1-1.5.2s-1 .1-1.5.1c.2.3.5.5.9.7.4.2.8.2 1.2.2.3 0 .7 0 1.1-.1.4-.1.8-.2 1.1-.4.2-.1.3-.1.4-.1.1 0 .2 0 .2.1s.1.2.1.3c0 .1.1.3.1.4 0 .1.1.3.1.4v.4c0 .2-.1.4-.3.6-.4.3-.9.6-1.5.8-.6.2-1.4.3-2.2.3-.6 0-1.1-.1-1.7-.3-.5-.2-1-.5-1.4-.9-.4-.4-.7-.9-1-1.4-.2-.5-.4-1.2-.4-1.8s.1-1.3.4-1.9c.3-.6.6-1.1 1-1.5.4-.4.9-.7 1.5-1 .6-.2 1.2-.3 1.8-.3.8 0 1.5.1 2.1.4.6.3 1 .7 1.4 1.1.3.4.6.9.7 1.3.1.5.2.9.2 1.2 0 .1 0 .3-.1.4.1 0 0 .1-.2.2zm-3.9-2.3c-.4 0-.8.1-1.2.4-.4.2-.6.6-.7.9.5 0 1.1-.1 1.7-.1.6 0 1.1-.1 1.6-.2-.1-.3-.3-.6-.6-.7-.2-.2-.5-.3-.8-.3zM619.3 333.8c-.5-.1-.7-.3-.7-.7v-.9c0-.3 0-.5.1-.7 0-.2.1-.3.2-.4.1-.1.3-.1.4-.1.2 0 .4 0 .8.1.4-1.2.8-2.3 1.2-3.5.4-1.1.9-2.2 1.3-3.2.2-.4.4-.6.8-.7.3-.1.6-.1 1-.1.3 0 .6-.1.9-.1h.8c.4 0 .7.2.9.6.4.7.8 1.7 1.3 2.9s1 2.5 1.5 3.9H630.5c.3 0 .6.2.6.5.1.3.1.6.1 1.1v.6c0 .2-.1.4-.2.5-.1.1-.3.2-.5.2.1.3.2.5.2.8.1.2.1.5.2.7 0 .1.1.2.1.3v.1c0 .3-.1.5-.4.6-.4.1-.7.2-1.1.3-.4.1-.8.1-1.2.1-.2 0-.4-.1-.5-.2s-.2-.3-.2-.5l-.5-1.9c-.7 0-1.4.1-2.1.1h-1.3c-.4 0-.9 0-1.3-.1-.1.3-.2.7-.2 1-.1.3-.1.6-.2 1s-.3.6-.7.6c-.3 0-.7 0-1.1-.1-.4-.1-.8-.2-1.1-.2-.3-.1-.4-.3-.4-.6v-.1-.3c0-.2.1-.4.2-.7.3-.4.3-.6.4-.9zm4.2-2.7h3c-.2-.7-.5-1.4-.7-2.2-.3-.7-.5-1.4-.8-2-.3.7-.5 1.5-.7 2.2-.4.6-.6 1.3-.8 2zM632.4 328.5c0-.3 0-.5.1-.7 0-.2.2-.3.4-.4.1 0 .3-.1.5-.1s.4 0 .6-.1h1.1c.2 0 .3 0 .4.1.1.1.1.2.1.3v.6c.3-.3.7-.5 1.1-.7.4-.2.9-.3 1.3-.3.3 0 .6.1.7.4.2.3.3.5.4.8.1.3.1.6.1.9v.8c0 .2-.1.5-.2.7-.1.2-.4.4-.7.6l-.6.3c-.2.1-.4.1-.6.1-.2 0-.4-.1-.5-.3-.1-.2-.2-.4-.2-.6v-.5c0-.2 0-.4-.1-.6-.2.1-.3.2-.5.3-.1.1-.3.2-.5.4v1.8c0 .6.1 1.1.1 1.5 0 .4.1.8.1 1.1v.6c0 .2-.1.4-.2.5-.1.1-.4.2-.8.2h-1.2c-.4 0-.6-.1-.7-.2-.1-.1-.2-.4-.2-.6-.1-.9-.2-1.8-.2-2.8s-.1-1.9-.1-2.8v-.6c.2-.2.2-.4.3-.7zM639.6 329.1v-.5c0-.1.1-.2.2-.3.1-.1.2-.1.3-.2.1 0 .3-.1.6-.1v-.5-.7-.7c0-.2 0-.4.1-.6.1-.2.2-.3.3-.4s.4-.2.7-.2c.3 0 .7-.1 1.3-.1.3 0 .5.1.6.2.1.1.2.3.2.6v2.3c.2 0 .4 0 .6.1.2 0 .4 0 .6.1.2 0 .4.1.5.2.1.1.1.3.1.5v.5c0 .2 0 .4-.1.5 0 .2-.1.4-.2.5-.1.1-.3.1-.6.2-.2 0-.3 0-.5.1h-.4c0 .4 0 .8.1 1.4 0 .5.1 1 .1 1.5s.1.9.1 1.3v.7c0 .2 0 .4-.1.5-.1.1-.3.2-.5.2-.5.1-.9.1-1.4.1-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.6-.1-.8-.2-1.7-.3-2.5-.1-.8-.1-1.7-.2-2.6l-.5-.1c-.3 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.5v-.4c-.2.1-.2 0-.2-.1zM653.1 333.8c0 .4-.1.8-.3 1.1-.2.3-.5.6-.8.8-.4.2-.8.4-1.3.5-.5.1-1 .2-1.6.2-.5 0-.9 0-1.3-.1s-.8-.2-1.1-.3c-.3-.1-.5-.3-.5-.6 0-.1 0-.2.1-.4 0-.2.1-.3.2-.5s.2-.4.2-.5c.1-.3.2-.4.4-.4.1 0 .2 0 .5.1.2.1.5.2.7.2.2 0 .5.1.6.1.3 0 .5 0 .7-.1.2-.1.2-.2.2-.3 0-.1-.1-.3-.3-.4-.2-.1-.4-.2-.7-.3-.3-.1-.6-.2-.9-.4-.3-.1-.6-.3-.9-.6-.3-.2-.5-.5-.7-.8-.2-.3-.3-.7-.3-1.2 0-.4.1-.8.3-1.2.2-.4.5-.6.9-.9.4-.2.8-.4 1.3-.6.5-.1 1-.2 1.5-.2.4 0 .9 0 1.3.1s.9.2 1.2.3c.2.1.3.2.4.3.1.1.2.3.2.5 0 .3 0 .5-.1.9-.1.3-.1.6-.2.8-.1.2-.1.3-.2.4-.1.1-.3.2-.5.2-.4 0-.7 0-1.1-.1-.2 0-.4-.1-.5-.2-.1-.1-.1-.3-.1-.5v-.1c-.2-.1-.4-.1-.6-.1-.3 0-.6 0-.8.1-.2.1-.3.2-.3.4 0 .1.1.3.3.4.2.1.5.2.8.3.3.1.6.2 1 .4.4.1.7.3 1 .6.3.2.6.5.8.8.4.5.5.8.5 1.3z" />
            </g>
          </g>
          {resources && (
            <>
              <ResourceLink
                r={resources[0]}
                svgComponent={resource1SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[0], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[1]}
                svgComponent={resource2SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[1], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[2]}
                svgComponent={resource3SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[2], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[3]}
                svgComponent={resource4SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[3], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[4]}
                svgComponent={resource5SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[4], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[5]}
                svgComponent={resource6SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[5], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
            </>
          )}
        </g>
      </g>
    </g>
  );
};
export default LanguageArtsLink;
